import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import ResponsiveForm from '../../Form';
import { validate } from '../../../../Helpers';
import {
  DEFAULT_ADD_VALUES,
  INPUTS,
  BANKS_FORM as form,
  BANKS_VALIDATIONS,
} from './config';

let AddBanksForm = ({ handleSubmit, loading = false, ...props }) => (
  <ResponsiveForm
    {...props}
    inputs={INPUTS}
    loading={loading}
    onSubmit={handleSubmit}
  />
);

AddBanksForm = reduxForm({
  form,
  validate: validate(BANKS_VALIDATIONS),
})(AddBanksForm);

const mapStateToProps = () => ({
  initialValues: { ...DEFAULT_ADD_VALUES },
});

export default connect(
  mapStateToProps
)(AddBanksForm);
